/* eslint-disable no-use-before-define */
import React, {
  useRef,
  useEffect,
  Children,
} from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import useStyle from './style';
import cx from '@/utils/cx';
import Swipe from '@/utils/swipe';

const getNumberOfGapItem = (numberOfVisibleItems) => (Math.floor(numberOfVisibleItems / 2));

const WheelChoose = ({
  validation,
  formatter,
  children,
  value,
  onChange,
  color,
  numberOfVisibleItems,
  className,
  ...rest
}) => {
  const theme = useTheme();
  const itemHeight = 6 * theme.sizes.base; // better we can ask button base md size
  const classes = useStyle({ itemHeight, color, numberOfVisibleItems });
  const innerContainerRef = useRef();
  const outerContainerRef = useRef();

  // for staled
  const freshEvents = useRef({});

  const setTranslate = (newY) => {
    innerContainerRef.current.style.transform = `translateY(${newY}px)`;
  };

  const getTranslate = () => (
    parseInt(innerContainerRef.current.style.transform.replace('translateY(', '').replace('px)', ''), 10) || 0
  );

  // eslint-disable-next-line no-shadow
  const handleValueChanges = (value) => {
    try {
      Children.forEach(children, (child, index) => {
        if (child.props.content === value) {
          [...innerContainerRef.current.children].forEach((childEl, indexEl) => {
            if (index === indexEl) {
              childEl.setAttribute('data-wheel-choose-selected', 'selected');
              setTranslate(
                -1 * childEl.offsetTop + (itemHeight * getNumberOfGapItem(numberOfVisibleItems)),
              );
            } else {
              childEl.removeAttribute('data-wheel-choose-selected');
            }
          });
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  freshEvents.current.updateValueBasedOnY = () => {
    const childrenArr = [...innerContainerRef.current.children];
    let currentOffsetTop = (getTranslate() - (
      itemHeight * getNumberOfGapItem(numberOfVisibleItems)
    ));
    const min = -1 * (itemHeight * (children.length - 1));
    const max = 0;

    if (currentOffsetTop < min) {
      currentOffsetTop = min;
    } else if (currentOffsetTop > max) {
      currentOffsetTop = max;
    }
    currentOffsetTop = Math.abs(currentOffsetTop);

    // https://stackoverflow.com/questions/8584902/get-closest-number-out-of-array
    const closestValue = childrenArr.reduce((prev, curr) => (
      Math.abs(curr.offsetTop - currentOffsetTop) < Math.abs(prev.offsetTop - currentOffsetTop)
        ? curr : prev
    ));

    const index = childrenArr.indexOf(closestValue);

    const selectedValue = Children.map(children, (x) => x)[index].props.content;

    onChange(selectedValue);

    const shouldMoveToSelectedItem = () => selectedValue === value;

    if (shouldMoveToSelectedItem) {
      handleValueChanges(selectedValue);
    }
  };

  useEffect(() => {
    const swipe = Swipe();
    swipe.setElement(outerContainerRef.current);
    swipe.on();

    let y = 0;
    swipe.beforeSwipe(() => {
      innerContainerRef.current.style.transitionDuration = '0s';
      y = getTranslate();
    });
    swipe.whileSwipe((_pos, diff) => {
      setTranslate(y + diff.y);
    });
    swipe.afterSwipe((
      // _pos, _diff, _time
    ) => {
      innerContainerRef.current.style.transitionDuration = null;
      freshEvents.current.updateValueBasedOnY();
    });

    return () => {
      swipe.off();
    };
  }, []);


  useEffect(() => {
    handleValueChanges(value);
  });

  return (
    <div
      className={cx(classes.wheelChoose, className)}
      ref={outerContainerRef}
      {...rest}
    >
      <div className="inner" ref={innerContainerRef}>
        {children}
      </div>
      <div className="top-shadow" />
      <div className="bottom-shadow" />
      <div className="selected-border" />
    </div>
  );
};

WheelChoose.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  onChange: PropTypes.func,
  color: PropTypes.string,
  numberOfVisibleItems: PropTypes.oneOf([3, 5, 7, 9]),
};

WheelChoose.defaultProps = {
  value: undefined,
  onChange: () => {},
  color: 'primary2',
  numberOfVisibleItems: 5,
};

export default WheelChoose;
